import { BaseModule } from './base.module';
import { DocumentLanguageModule } from './document-language.module';
import { StorageModule } from './storage.module';

export class TextToSpeechModule extends BaseModule {

    enabled = false;
    speechSynthesis = window.speechSynthesis;
    mouseTargets = 'h1, h2, h3, h4, h5, h6, p, blockquote, a, button, svg, span';
    inputTargets = 'input, select, textarea, a, button:not(disabled)';

    initialize() {
        this.handleActivation();

    }

    handleActivation() {
        if (document.documentElement.querySelector('body').classList.contains('accessibility-features')) {
            this.enabled = true;
            this.setupVoices();
        }
    }

    setupVoices() {
        if (typeof window.speechSynthesis !== 'undefined') {
            this.voices = this.speechSynthesis.getVoices();
            this.setupEventListeners();
        }
    }

    handleElementFocus(event) {
        console.log('focus-like event received', event);
        let elementType = 'element';
        if (typeof event.target.localName !== 'undefined') {
            console.log('local name:', event.target.localName);
            switch (event.target.localName) {
                case 'h1':
                case 'h2':
                case 'h3':
                case 'h4':
                case 'h5':
                case 'h6':
                    elementType = 'Titel';
                    break;
                case 'p':
                    elementType = 'Paragraaf';
                    break;
                case 'span':
                    elementType = 'Inline element';
                    break;
                case 'blockquote':
                    elementType = 'Citaat';
                    break;
                // case 'cite':
                //     elementType = "Geciteerde";
                // case 'ol':
                //     elementType = "Geördende en genummerde lijst";
                // case 'ul':
                //     elementType = "Ongenummerde lijst";
                //     break;
                case 'li':
                    elementType = "lijst-item";
                    break;
                case 'a':
                    elementType = 'Link';
                    break;
                case 'button':
                    elementType = 'Knop';
                case 'snall':
                    elementType = 'Kleine tekst';
                    break;
                case 'input':
                    elementType = 'Eenvoudige invoerveld';
                    let placeholder = event.target.placeholder;
                    let p = `met plaatshouder ${placeholder}`;
                    if (placeholder) {
                        placeholder = p;
                    }
                    this.speak(`Eenvoudige invoerveld ${placeholder}, de waarde is nu: "${event.target.value}"`);
                    break;
                case 'svg':
                case 'use':
                    elementType = 'Grafisch element';
                    let closestLink = event.target.closest('a');
                    if (closestLink && closestLink.hasAttribute('title') === true) {
                        this.speak(`De titel van het grafische element binnen deze link is: ${closestLink.getAttribute('title')}. Het link doel is ${closestLink.href}`);
                    }
                    let queryTitle = event.target.querySelector('title');
                    console.log('queryTitle', queryTitle);
                    if (queryTitle) {
                        this.speak(`Eeen schaalbare afbeelding: ${queryTitle.textContent}`);
                    }
                    if (event.target.localName === 'use') {
                        queryTitle = event.target.parentNode.querySelector('title')
                        if (queryTitle) {
                            this.speak(`Een schaalbare afbeelding, de titel is: "${queryTitle.textContent}"`);
                        }
                    }
                    break;

            }
        }
        if (event.target.textContent) {
            this.speak(`${elementType}: ${event.target.textContent}`);
        }
        if (event.target.localName == 'a' && typeof event.target.href !== 'undefined' && typeof event.target.href !== null) {
            let href = event.target.href;
            href.replace('.', ' punt ');
            href.replace('nl', 'NL');
            this.speak(`Het link doel is: ${href}`);
        }
        if (event.target.hasAttribute('title')) {
            this.speak(`De titel van dit element is: ${event.target.getAttribute('title')}`);
        }
        if (event.target.hasAttribute('alt')) {
            this.speak(`De alternatieve tekst van dit element is: ${event.target.getAttribute('alt')}`);
        }
        if (event && typeof event.target !== 'undefined') {
            event.target.classList.add('accessibility-border');
        }
    }

    handleElementBlur(event) {
        console.log('blur-like event received', event);
        // this.speak('');
        if (event && typeof event.target !== 'undefined') {
            event.target.classList.remove('accessibility-border');
            this.speechSynthesis.cancel();
        }
    }

    setupEventListeners() {
        if (speechSynthesis.onvoiceschanged !== undefined) {
            speechSynthesis.onvoiceschanged = this.setupVoices;

            this.introduce();
            // focusable targets, that will actually do something when they receive focus (inputs)
            document.querySelectorAll(this.inputTargets).forEach((element) => {
                element.addEventListener('focus', (event) => {
                    // console.log('focus', event);
                    this.handleElementFocus(event);
                });
            });
            document.querySelectorAll(this.inputTargets).forEach((element) => {
                element.addEventListener('blur', (event) => {
                    // console.log('focus', event);
                    this.handleElementBlur(event);
                });
            });

            // mouseover targets that can not be focused
            document.querySelectorAll(this.mouseTargets).forEach((element) => {
                element.addEventListener('mouseover', (event) => {
                    // console.log('focus', event);
                    this.handleElementFocus(event);
                });
            });
            document.querySelectorAll(this.mouseTargets).forEach((element) => {
                element.addEventListener('mouseout', (event) => {
                    // console.log('focus', event);
                    this.handleElementBlur(event);
                });
            });

        }
    }

    introduce() {
        let documentLanguageModule = new DocumentLanguageModule();
        let language = documentLanguageModule.getLanguageFromDocument();

        let storageModule = new StorageModule();
        let introduced = storageModule.getItem('sessionStorage', 'introduced-text-to-speech-accessibility');

        console.log('introduced?', introduced);

        if (introduced == null) {
            this.speak(`Welkom in de toegankelijkheidsweergave van website "${window.location.hostname}."`);
            this.speak(`Zweef je muisaanwijzer over elementen om meer informatie te verkrijgen.`);
            this.speak(`Gebruik toetsenbordnavigatie om te navigeren naar knoppen.`);
            this.speak(`Als je opnieuw deze uitleg wilt horen, sluit dan alle vensters van deze browser.`);
            this.speak(`Nu volgt uitleg over de pagina.`);
        }
        this.speak(`Paginatitel: "${document.title}". De website is ${window.location.hostname}`);
        if (window.location.pathname == '/') {
            this.speak(`Je bent op de hoofdpagina van deze website.`);
        }
        if (window.location.pathname.length > 1) {
            this.speak(`De subpagina is ${window.location.pathname}`);
        }
        let h1 = document.documentElement.querySelector('h1');
        let h2 = document.documentElement.querySelector('h2');
        let h3 = document.documentElement.querySelector('h3');
        let h4 = document.documentElement.querySelector('h4');
        let h5 = document.documentElement.querySelector('h5');
        let h6 = document.documentElement.querySelector('h6');
        if (h1) {
            this.speak(`De eerste belangrijke titel is ${h1.textContent}`);
        }
        if (h2) {
            this.speak(`De tweede belangrijke titel is ${h2.textContent}`);
        }
        if (h3) {
            this.speak(`De derde belangrijke titel is ${h3.textContent}`);
        }
        if (h4) {
            this.speak(`De vierde belangrijke titel is ${h4.textContent}`);
        }
        if (h5) {
            this.speak(`De vijfde belangrijke titel is ${h5.textContent}`);
        }
        if (h6) {
            this.speak(`De zesde belangrijke titel is ${h6.textContent}`);
        }

        storageModule.setItem('sessionStorage', 'introduced-text-to-speech-accessibility', true);
        console.log('introduced? after setting it', introduced);
    }

    speak(utterance) {
        this.utterance = new SpeechSynthesisUtterance(utterance);
        this.speechSynthesis.speak(this.utterance);
    }
}
